export interface PrefilledDealModel {
    type: number;
    userID: number;
    linkID: number;
    username: string;
    category: number;
    url: string;
    title: string;
    content: string;
    asin: string;
    upc: string;
    priceDeal: number;
    priceOld: number;
    shipping: number;
    store: string;
    imageURL: string;
    imagesURL: [string];
    coupon: number;
    promoCode: string;
    promotionType: number;
    expire: string;
}
export const emptyPrefilledDeal = (url): PrefilledDealModel => ({
    type: null,
    userID: null,
    linkID: null,
    username: null,
    category: null,
    url: url,
    title: null,
    content: null,
    priceDeal: null,
    priceOld: null,
    shipping: null,
    store: null,
    asin: null,
    upc: null,
    imageURL: null,
    imagesURL: null,
    coupon: null,
    promoCode: null,
    promotionType: null,
    expire: null,
});
